module.exports = __webpack_public_path__ + "img/search_01.ddc518d0.png";